"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLayoutEqual = isLayoutEqual;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
function isLayoutEqual(a, b) {
  const compareKeys = ['sm.x', 'sm.y', 'sm.w', 'sm.h', 'lg.x', 'lg.y', 'lg.w', 'lg.h'];
  const normalizedA = (0, _pick2.default)(a, compareKeys);
  const normalizedB = (0, _pick2.default)(b, compareKeys);
  return (0, _isEqual2.default)(normalizedA, normalizedB);
}